function millisecondsToMinutesAndSeconds(
  milliseconds: number,
  includeSign = false,
): string {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const sign =
    milliseconds < 0 ? '-' : includeSign && milliseconds > 0 ? '+' : '';
  const absoluteSeconds = Math.abs(totalSeconds);
  const totalMinutes = Math.floor(absoluteSeconds / 60);
  const seconds = absoluteSeconds - totalMinutes * 60;

  if (totalMinutes < 60) {
    return `${sign}${totalMinutes}:${
      seconds.toString().length === 1 ? '0' : ''
    }${seconds}`;
  }

  const totalHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes - totalHours * 60;

  return `${sign}${totalHours}:${
    minutes.toString().length === 1 ? '0' : ''
  }${minutes}:${seconds.toString().length === 1 ? '0' : ''}${seconds}`;
}

export default millisecondsToMinutesAndSeconds;
